import { Controller } from "@hotwired/stimulus"
import LocationService from "../services/location_service.js"
import { LOCATION_TEXT } from "../constants/location.js"

export default class extends Controller {
  static targets = ['display', 'count']
  static outlets = ['mapLocationPicker']

  connect() {
    this.updateDisplay();
    this.setupEventListeners();
  }

  disconnect() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('location:changed', this.handleLocationChange.bind(this));
    window.addEventListener('storage', this.handleStorageChange.bind(this));
  }

  removeEventListeners() {
    document.removeEventListener('location:changed', this.handleLocationChange.bind(this));
    window.removeEventListener('storage', this.handleStorageChange.bind(this));
  }

  handleLocationChange() {
    this.updateDisplay();
  }

  handleStorageChange(event) {
    if (event.key === LocationService.CONFIG.STORAGE_KEY) {
      this.updateDisplay();
    }
  }

  // Called by map location picker when location changes
  updateDisplay() {
    const displayText = LocationService.getLocationDisplayText();
    const locationData = LocationService.getCurrentLocationData();
    
    // Update standard display targets (for other pages like homepage)
    this.displayTargets.forEach(element => {
      element.textContent = displayText;
    });

    // Update count targets with simple sentence format (for offer pages)
    this.countTargets.forEach(element => {
      if (locationData && locationData.address && locationData.radius) {
        element.textContent = `${locationData.address} (${locationData.radius}km)`;
      } else {
        element.textContent = LOCATION_TEXT.ALL_LOCATIONS;
      }
    });
  }


  // Target callback - automatically update when new display targets are added
  displayTargetConnected() {
    this.updateDisplay();
  }

  // Public method for manual refresh
  refresh() {
    this.updateDisplay();
  }
}